import React, { Component } from "react";
import LoginForm from '../components/login-form.jsx';
class Login extends Component {

	render() {
		return (
			<React.Fragment>
				<section className="hero is-medium is-primary is-bold">
					<div className="hero-body">
						<div className="container">
							<h1 className="title">Repository immagini</h1>
							<h2 className="subtitle">Login</h2>
						</div>
					</div>
				</section>
				<section className="section">
					<div className="container">
						<div className="columns is-centered has-text-left">
							<div className="column is-narrow">
								<LoginForm history={this.props.history}/>
							</div>
						</div>
					</div>
				</section>
			</React.Fragment>
		)
	}
}

export default Login;


// WEBPACK FOOTER //
// ./src/views/login.jsx